module.exports = __webpack_public_path__ + "img/08.8eab5562.png";